import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import moment from 'moment'
import disposal from '../../redux/actions/disposal'
import setuju from '../../redux/actions/setuju'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const { REACT_APP_BACKEND_URL } = process.env

// ── Helpers ───────────────────────────────────────────────────────────────────

const toBase64 = (url, headers = {}) =>
  fetch(url, { headers })
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror  = reject;
          reader.readAsDataURL(blob);
        })
    );

const formatName = (nama) => {
  if (!nama) return null
  if (nama.length <= 15) {
    return nama.split(' ').map((w) => (w ? w[0].toUpperCase() + w.slice(1) : '')).join(' ')
  }
  return (
    nama.slice(0, 13).split(' ').map((w) => (w ? w[0].toUpperCase() + w.slice(1) : '')).join(' ') + '.'
  )
}

const toRupiah = (num) =>
  `Rp ${(parseInt(num) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`

const buildApprovalHeader = (label, colSpan = 1) => ({
  text:      label,
  bold:      true,
  alignment: 'center',
  fontSize:  6,
  border:    [true, true, true, true],
  fillColor: '#f2f2f2',
  margin:    [2, 3, 2, 3],
  colSpan,
})

const buildApprovalBody = (item) => {
  const border = [true, true, true, true]

  if (!item) {
    return {
      stack:  [{ text: '\n\n\n-\n\n\n-', alignment: 'center', fontSize: 6 }],
      border,
      margin: [2, 13, 2, 13],
    }
  }

  const name    = formatName(item.nama)
  const date    = moment(item.updatedAt).format('DD/MM/YYYY')
  const status  = item.status === 0 ? `Reject (${date})` : item.status === 1 ? `Approve (${date})` : ''
  const jabatan = item.jabatan ? item.jabatan.toUpperCase() : ''

  return {
    stack: [
      { text: status,      alignment: 'center', fontSize: 6, margin: [0, 13, 0, 0] },
      { text: '\n\n' },
      { text: name || '', alignment: 'center', fontSize: 6 },
      { text: jabatan,     alignment: 'center', fontSize: 6, margin: [0, 5, 0, 0] },
    ],
    border,
    margin: [2, 13, 2, 13],
  }
}

// ─────────────────────────────────────────────────────────────────────────────

class FormPersetujuan extends Component {

  prosesDownload = async () => {
    const token = localStorage.getItem('token')
    const { detailDis } = this.props.disposal
    await this.props.getApproveSetDisposal(token, detailDis[0].no_persetujuan)
    await this.props.getNewDetailDisposal(token, detailDis[0].no_persetujuan, 'persetujuan')
    this.downloadForm()
  }

  downloadForm = async () => {
    const { detailNew } = this.props.disposal
    const { disApp }    = this.props.setuju

    // ── Logo ─────────────────────────────────────────────────────────────────
    let logoBase64 = null
    try {
      const token = localStorage.getItem('token')

      logoBase64 = await toBase64(
        `${REACT_APP_BACKEND_URL}/masters/logo.png`,
        { Authorization: `Bearer ${token}` }
      )
    } catch (e) {
      console.warn('Logo gagal dimuat:', e)
    }

    // ── Approval lists
    const buatList   = disApp?.pembuat   ? [...disApp.pembuat]   : []
    const setujuList = disApp?.penyetuju ? [...disApp.penyetuju] : []

    if (!buatList.length)   buatList.push(null)
    if (!setujuList.length) setujuList.push(null)

    const totalCols      = buatList.length + setujuList.length
    const approvalWidths = Array(totalCols).fill('*')

    // Row 1: group header dengan colSpan
    const approvalHeaderRow = [
      { ...buildApprovalHeader('Dibuat oleh,', buatList.length) },
      ...Array(buatList.length - 1).fill({ text: '', border: [false, false, false, false] }),
      { ...buildApprovalHeader('Disetujui oleh,', setujuList.length) },
      ...Array(setujuList.length - 1).fill({ text: '', border: [false, false, false, false] }),
    ]

    // Row 2: isi nama, status, jabatan per orang
    const approvalBodyRow = [
      ...buatList.map((item)   => buildApprovalBody(item)),
      ...setujuList.map((item) => buildApprovalBody(item)),
    ]

    // ── Info surat ────────────────────────────────────────────────────────────
    const firstDetail  = detailNew?.[0]
    const datePersetujuan = firstDetail !== undefined ? firstDetail.date_persetujuan : new Date()
    const dateStr      = `Bandung, ${moment(datePersetujuan).locale('id').format('DD MMMM YYYY')}`
    const ceoName      = firstDetail !== undefined && firstDetail.ceo ? firstDetail.ceo : ''

    // ── Tabel aset ────────────────────────────────────────────────────────────
    const itemHeader = [
      'No.',
      'Nomor\nAset / Inventaris',
      'Area\n(Cabang/Depo/CP)',
      'Nama Barang',
      'Acquisition Value',
      `Nilai Buku ${moment(detailNew[0].date_persetujuan).format("MMM'YY")}`,
      'Nilai Jual',
      'Tanggal\nPerolehan',
      'Keterangan',
    ].map((h) => ({
      text:      h,
      bold:      true,
      alignment: 'center',
      fillColor: '#f2f2f2',
      border:    [true, true, true, true],
      fontSize:  6,
    }))

    const itemRows = (detailNew || []).map((item, index) => [
      { text: String(index + 1),                                          alignment: 'center', border: [true,true,true,true], fontSize: 6 },
      { text: `${item.no_asset}`,                                         alignment: 'center', border: [true,true,true,true], fontSize: 6 },
      { text: `${item.area}`,                                             alignment: 'left', border: [true,true,true,true], fontSize: 6 },
      { text: item.nama_asset === null ? '-' : `${item.nama_asset}`,      alignment: 'left', border: [true,true,true,true], fontSize: 6 },
      { text: toRupiah(item.nilai_acquis ?? 0),                           alignment: 'center', border: [true,true,true,true], fontSize: 6 },
      { text: toRupiah(item.nilai_buku_persetujuan ?? 0),                 alignment: 'center', border: [true,true,true,true], fontSize: 6 },
      { text: toRupiah(item.nilai_jual  ?? 0),                            alignment: 'center', border: [true,true,true,true], fontSize: 6 },
      { text: moment(item.dataAsset?.tanggal).format('DD/MM/YYYY'),       alignment: 'center', border: [true,true,true,true], fontSize: 6 },
      { text: `${item.keterangan}`,                                       alignment: 'left', border: [true,true,true,true], fontSize: 6 },
    ])

    // Baris total nilai buku & nilai jual
    const totalNilaiAcquis = (detailNew || []).reduce((sum, item) => sum + (parseInt(item.nilai_acquis) || 0), 0)
    const totalNilaiBuku = (detailNew || []).reduce((sum, item) => sum + (parseInt(item.nilai_buku_persetujuan) || 0), 0)
    const totalNilaiJual = (detailNew || []).reduce((sum, item) => sum + (parseInt(item.nilai_jual) || 0), 0)

    const totalRow = [
      { text: 'Total', bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 6, colSpan: 4, fillColor: '#f2f2f2' },
      { text: '', border: [false,false,false,false], fontSize: 6 },
      { text: '', border: [false,false,false,false], fontSize: 6 },
      { text: '', border: [false,false,false,false], fontSize: 6 },
      { text: toRupiah(totalNilaiAcquis), bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 6, fillColor: '#f2f2f2' },
      { text: toRupiah(totalNilaiBuku), bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 6, fillColor: '#f2f2f2' },
      { text: toRupiah(totalNilaiJual), bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 6, fillColor: '#f2f2f2' },
      { text: '', border: [true,true,true,true], fontSize: 6 },
      { text: '', border: [true,true,true,true], fontSize: 6 },
    ]

    // ── Doc definition ────────────────────────────────────────────────────────
    const docDefinition = {
      pageSize:        'A4',
      pageOrientation: 'landscape',
      pageMargins:     [25, 25, 25, 30],

      footer: (currentPage, pageCount) => ({
        text:      `Halaman ${currentPage} dari ${pageCount}`,
        alignment: 'center',
        fontSize:  6,
        margin:    [0, 8, 0, 0],
      }),

      content: [

        // ── Header: Logo + Nama Perusahaan + Judul ────────────────────────────
        {
          columns: [
            {
              stack: [
                logoBase64
                  ? { image: logoBase64, width: 40, height: 50, margin: [0, 0, 0, 2] }
                  : { text: '' },
                { text: 'PT. Pinus Merah Abadi', bold: true, fontSize: 6, margin: [0, 4, 0, 0] },
              ],
              width: 170,
            },
            {
              text:      'PERSETUJUAN DISPOSAL ASET',
              style:     'title',
              alignment: 'center',
              margin:    [0, 16, 0, 0],
            },
            { text: '', width: 170 },
          ],
          margin: [0, 0, 0, 10],
        },

        // ── Info surat ────────────────────────────────────────────────────────
        { text: dateStr, fontSize: 6, margin: [0, 0, 0, 4] },
        {
          columns: [
            { text: 'Hal', width: 100, fontSize: 6 },
            { text: ': Persetujuan Disposal Asset', fontSize: 6 },
          ],
          margin: [0, 0, 0, 8],
        },
        { text: 'Kepada Yth.',           fontSize: 6 },
        { text: `Bpk/Ibu ${ceoName}`,   fontSize: 6, margin: [0, 0, 0, 8] },

        { text: 'Dengan Hormat,',         fontSize: 6 },
        { text: 'Sehubungan dengan surat permohonan disposal aset area PMA terlampir', fontSize: 6 },
        {
          text:   'Dengan ini kami mohon persetujuan untuk melakukan disposal aset dengan perincian sbb :',
          fontSize: 6,
          margin:   [0, 0, 0, 8],
        },

        // ── Tabel Detail Aset ─────────────────────────────────────────────────
        {
          table: {
            headerRows: 1,
            widths:     ['auto', 65, 65, '*', 55, 55, 55, 55, '*'],
            body:       [itemHeader, ...itemRows, totalRow],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Penutup ───────────────────────────────────────────────────────────
        {
          text:   'Demikian hal yang kami sampaikan perihal persetujuan disposal aset, atas perhatiannya kami mengucapkan terima kasih',
          fontSize: 6,
          margin:   [0, 0, 0, 10],
        },

        // ── Tabel Approval ────────────────────────────────────────────────────
        {
          table: {
            widths: approvalWidths,
            body:   [approvalHeaderRow, approvalBodyRow],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Nomor Form ────────────────────────────────────────────────────────
        { text: 'FRM-FAD-121 REV 03 (1)', fontSize: 6 },
      ],

      styles: {
        title: {
          bold:       true,
          fontSize:   6,
          decoration: 'underline',
        },
      },

      defaultStyle: {
        fontSize: 6,
        font:     'Roboto',
      },
    }

    const fileName = `Form Persetujuan Disposal ${firstDetail?.no_persetujuan ?? ''} ${moment().format('DD MMMM YYYY')}.pdf`

    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).download(fileName, () => resolve(fileName))
      } catch (err) {
        reject(err)
      }
    })
  }

  render() {
    return (
      <Button color="info" className="ml-2" onClick={this.prosesDownload}>
        Download Form Persetujuan PDF
      </Button>
    )
  }
}

const mapStateToProps = (state) => ({
  asset:    state.asset,
  depo:     state.depo,
  mutasi:   state.mutasi,
  disposal: state.disposal,
  setuju:   state.setuju,
  user:     state.user,
  tempmail: state.tempmail,
  newnotif: state.newnotif,
  dokumen:  state.dokumen,
})

const mapDispatchToProps = {
  getApproveDisposal:    disposal.getApproveDisposal,
  getNewDetailDisposal:  disposal.getNewDetailDisposal,
  getApproveSetDisposal: setuju.getApproveSetDisposal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormPersetujuan)